import { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useGoogleOauthClientId } from '@/data/Content/GoogleOauthClientId';

type Props = {
	children?: ReactNode;
}

export const InjectGoogleOAuthProvider = ({ children }: Props) => {
	const { googleOauthClientId } = useGoogleOauthClientId();

	if (!googleOauthClientId) {
		return <>{children}</>;
	}

	return <GoogleOAuthProvider clientId={googleOauthClientId}>{children}</GoogleOAuthProvider>;
};

